import React from "react";

const ReleaseV1 = () => {
  return (
    <div className="release_content">
      <h3>Alpha v1.1.0</h3>
      <p>Released on 5 May 2023</p>
      <h2>Landing Page Features & Enhacements</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            Introduced 3 new section Business,Domain,By Maersk Model with
            datasets tagged with them.
          </span>
        </li>
        <li>
          {" "}
          <span>
            New theme added with card view having respective icon and count on
            different section of Business,Domain,By Maersk Model
          </span>
        </li>
      </ul>

      <h2>Global Search</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            Global search is now more advanced,On typing it shows the match of
            the keyword defined in the right of the search result{" "}
          </span>
        </li>
        <li>
          {" "}
          <span>
            You can either select from the result which navigates you to the
            individual page of the dataset or pressing enter will navigate to
            the View all page where the match keyword datasets will be present
          </span>
        </li>
      </ul>
      <h2>Individual Dataset Page</h2>
      <hr />
      <ul>
        <li>
          {" "}
          Details pop up has now the dataset accessed in last 1 month data shown
          along with business,domain & Owner information
        </li>
      </ul>
      <h2>Global Search</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            Search by any keyword "customer","shipment" will go to the
            respective dataset with key word match.
          </span>
        </li>
      </ul>
      <h2>View All Datasets Page</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            The page is now more enhanced and it shows all the datasets
            information section wise.
          </span>
        </li>
        <li>
          {" "}
          <span>Search Bar for searching across the pages</span>
        </li>
        <li>
          {" "}
          <span>
            Pagination and a header showing the results as well as page & count
            information
          </span>
        </li>
        <li>
          {" "}
          <span>
            Data like business,domain,owner,by maersk model categories are now
            in small button with icons
          </span>
        </li>
        <li>
          {" "}
          <span>
            Tooltip added on these button to specify actual meaning of it.
          </span>
        </li>
        <li>
          {" "}
          <span>
            We have also introduced a filter section on the left where user can
            do multi select from datasource,layer,business,domain,By Maersk
            Model and apply to see the datasets associated.
          </span>
        </li>
      </ul>
      <h2>Insights</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            We have introduced a option in Navigation Bar as "Insights" where it
            shows user behaviour analytics from Microsoft Clarity
          </span>
        </li>
      </ul>
    </div>
  );
};

export default ReleaseV1;
